<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div style="margin-bottom: 10px;color: #3ae2c4">
          <el-switch
            v-model="childSelect"
            @change="switchFn"
          >
          </el-switch>
          查找下级地区
        </div>
        <zv-table :table="table" ref="dataTable">
          <div slot="ctrl-button">
            <el-button type="primary" @click="goDetails">新增</el-button>
          </div>
        </zv-table>

        <zv-dialog
          width="400px"
          :title="isEdit ? '修改地区' : '新增地区'"
          :showDialog.sync="showFormDialog"
          @close-dialog="closeFormDialog"
        >
          <div slot="content">
            <el-form
              ref="myForm"
              label-width="140px"
              :model="formData"
              :rules="formRules"
              status-icon
            >
              <el-form-item label="地区名称：" prop="area_name">
                <el-input v-model="formData.area_name" clearable></el-input>
              </el-form-item>

              <el-form-item label="上级地区：" prop="parent_area_id">
                <el-select
                  v-model="formData.parent_area_id"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in areaListData"
                    :key="item.id"
                    :label="item.area_name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="地区类别：" prop="area_type">
                <el-select
                  v-model="formData.area_type"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in areaTypeData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="经度lon：" prop="longitude">
                <el-input v-model="formData.longitude" clearable></el-input>
              </el-form-item>
              <el-form-item label="纬度lat：" prop="latitude">
                <el-input v-model="formData.latitude" clearable></el-input>
              </el-form-item>
              <el-form-item label="hc_key：" prop="hc_key">
                <el-input v-model="formData.hc_key" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="btns">
            <el-button @click="showFormDialog = false">取消</el-button>
            <el-button type="primary" @click="submitForm">确定</el-button>
          </div>
        </zv-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import api from "./api";
import addFormMixin from "@/mixins/addFormMixin";
export default {
  name: "AreaList",
  mixins: [addFormMixin],
  components: {
  },
  data() {
    let vm = this;
    return {
      table: {
        api: api.areaList,
        switch: false,
        query: {
          showall: 1
        },
        searchData: [
          {
            type: "input",
            model: "id",
            placeholder: "ID"
          },
          {
            type: "input",
            model: "area_name",
            placeholder: "地区名称"
          },
          {
            type: "select",
            model: "area_type",
            placeholder: "地区类型",
            option: vm.$enums.AreaType.list
          },
          {
            type: "select",
            model: "is_import",
            placeholder: "是否重点区域",
            option: [
              {label: "是", value: 1},
              {label: "否", value: 0},
            ]
          },
        ],
        columns: [
          {
            title: "地区名称",
            key: "area_name",
            minWidth:"150",
            showTooltip: true
          },
          {
            title: "地区所属",
            key: "full_area_name",
            minWidth:"150",
            showTooltip: true
          },
          {
            title: "地区类别",
            key: "area_type",
            render(h, ctx) {
              let type = ctx.row.area_type
              let retStr = vm.$enums.AreaType.getName(type)

              return h("div", retStr || '--');
            }
          },
          {
            title: "风险指数",
            key: "risk_score",
          },
          // {
          //   title: "经度lon",
          //   key: "longitude",
          // },
          // {
          //   title: "纬度lat",
          //   key: "latitude",
          // },
          // {
          //   title: "hc_key",
          //   key: "hc_key",
          // },
          {
            title: "操作人",
            key: "last_admin_username",
            minWidth: "60",
            render(h, ctx) {
              let status = ctx.row.last_admin_username;
              let statusText;
              if (status == "") {
                statusText = "--";
              } else {
                statusText = status;
              }
              return h("span", statusText);
            }
          },
          {
            title: "操作",
            fixed: "right",
            minWidth:"110",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doEdit.bind(this, ctx.row)
                  }
                },
                "修改"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text",
                    style: ctx.row.status == 0 ? "":"color: red"
                  },
                  on: {

                    click: vm.doStatusFn.bind(this, ctx.row)
                  }
                },

                ctx.row.status == 0 ? "启用":"禁用"
              );

              let arr = [];
              arr.push(editBtn);

              arr.push(delBtn);

              return h("span", arr);
            }
          }
        ]
      },
      formDataOri: {
        area_name: '',  // 地区名字
        parent_area_id: '',  // 上级地区ID（顶级是0）
        area_type: '',    // 地区类别 1 洲 2 国 3省 4市
        longitude: '',
        latitude: '',
        hc_key: '',
      },
      formRules: {
        area_name: [{
          required: true,
          message: "地区名称不能为空",
          trigger: "blur"
        }],
        parent_area_id: {
          required: true,
          message: "上级地区不能为空",
          trigger: "blur"
        },
        area_type: {
          required: true,
          message: "地区类别不能为空",
          trigger: "blur"
        }
      },
      areaListData: [],   // 全部区域
      areaTypeData: vm.$enums.AreaType.list,   // 区域类型数据
      adddApi: api.addArea,
      editApi: api.editArea,
      deleteApi: api.deleteArea,
      addSuccessMsg: '添加地区成功',
      editSuccessMsg: '编辑地区成功',
      deleteSuccessMsg: '删除地区成功',
      addTurn: this.$route.query.add,
      childSelect: false
    };
  },

  computed: {

  },

  methods: {
    async getAreaListData() {
      let res = await api.areaList({
        page: 1,
        pagesize: this.$enums.allPageSize
      })
      console.log(res)
      let filterData = res.list.filter(item => item.area_type != 4)
      filterData.unshift({
        id: 0,
        area_name: '顶级'
      })

      this.areaListData = filterData
    },
    // lafite - 1.2.1 2020-5-28 - 弹窗默认显示
    DialogShow() {
      if(this.addTurn) {
        this.showFormDialog = true
      }
    },
    switchFn() {
      if(this.childSelect) {
        this.$set(this.table,"switch",true)
        this.$set(this.table.searchData[1],"model","parent_area_name")
      }else {
        this.$set(this.table,"switch",false)
        this.$set(this.table.searchData[1],"model","area_name")
      }
    },
    // 新增地区库管理1.4
    goDetails() {
      let routeData = this.$router.resolve('/data-analysis/areaList_details')
      window.open(routeData.href, '_blank');
    },
    // 编辑新增
    doEdit(row) {
      let routeData = this.$router.resolve('/data-analysis/areaList_details?id='+ row.id)
      window.open(routeData.href, '_blank');
    },
    async doStatusFn(row) {
      let res = await api.statusArea({
        id: row.id,
        status: row.status == 0 ? 1:0
      })
      this.$refs.dataTable.refresh();
      let msg = row.status == 0 ? "开启成功":"禁用成功"
      this.$message.success(msg);
    }
  },

  created() {
    this.getAreaListData()
    this.DialogShow()
  },

  mounted() {

  },
  beforeDestroy() {

  }
};
</script>

<style lang="less" scoped>

</style>
